import { Delete, Tabs } from "../shared";
import VeevaForm from "./VeevaForm";
import ViewVeeva from "./ViewVeeva";
import { DELETE_VEEVA_DATA, UPDATE_VEEVA_DATA } from "./query";

const SubComponent = ({ data }) => {
    const { id } = data;
    return (
        <Tabs
            tabItems={[
                {
                    id: `view-${id}`,
                    name: "View Veeva",
                    content: <ViewVeeva data={data} />,
                },
                {
                    id: `update-${id}`,
                    name: "Update Veeva",
                    content: (
                        <>
                            <h5 className="mb-4">Update Veeva</h5>
                            <VeevaForm
                                query={UPDATE_VEEVA_DATA}
                                formType="update"
                                formData={data}
                            />
                        </>
                    ),
                },
                {
                    id: `delete-${id}`,
                    name: "Delete Veeva",
                    content: (
                        <Delete
                            id={id}
                            title="Veeva Data"
                            query={DELETE_VEEVA_DATA}
                            cacheName="allVeevaData"
                        />
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
